import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { z } from "zod";

export const WORKSPACE_CONTEXT_SERVER_NAME = "workspace_context" as const;
export const WORKSPACE_CONTEXT_SET_FACT_TOOL_NAME = "set_company_fact";
export const WORKSPACE_CONTEXT_STATUS_TOOL_NAME = "workspace_status";
export const WORKSPACE_CONTEXT_POST_TOOL_NAME = "workspace_post";

export const WORKSPACE_CONTEXT_TOOLS_METADATA = [
  {
    name: WORKSPACE_CONTEXT_SET_FACT_TOOL_NAME,
    description:
      "Establish a company fact once, by key, for every agent to quote afterwards. First write wins: if the key is already set you are told the established value instead.",
    schema: {
      key: z
        .string()
        .min(1)
        .describe(
          "A short stable name for the fact, such as 'fiscal_year_end' or 'hq_city'."
        ),
      value: z.string().min(1).describe("The fact, in one or two sentences."),
    },
    stake: "never_ask",
    displayLabels: {
      running: "Establishing a company fact",
      done: "Company fact established",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
  {
    name: WORKSPACE_CONTEXT_STATUS_TOOL_NAME,
    description:
      "List what agents in this workspace have recently worked on, finished or failed, in the conversations you can open.",
    schema: {},
    stake: "never_ask",
    displayLabels: {
      running: "Reading recent workspace activity",
      done: "Read recent workspace activity",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
  {
    name: WORKSPACE_CONTEXT_POST_TOOL_NAME,
    description:
      "Post a short update to the workspace activity feed, visible to whoever can open this conversation.",
    schema: {
      headline: z.string().min(1).describe("One line saying what happened."),
      body: z
        .string()
        .min(1)
        .describe("A sentence or two of detail worth keeping."),
    },
    stake: "never_ask",
    displayLabels: {
      running: "Posting to the workspace feed",
      done: "Posted to the workspace feed",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const WORKSPACE_CONTEXT_SERVER = {
  serverInfo: {
    name: WORKSPACE_CONTEXT_SERVER_NAME,
    version: "1.0.0",
    description:
      "Company facts every agent quotes, and the workspace's recent activity: what is running, what finished, what failed.",
    authorization: null,
    icon: "ActionListCheckIcon",
    documentationUrl: null,
  },
  tools: WORKSPACE_CONTEXT_TOOLS_METADATA,
} as const satisfies ServerMetadata;
